import React, { useEffect, useState } from 'react';
import { ReactComponent as Vine1 } from '../../images/svg/vine7.svg';
import { ReactComponent as Vine2 } from '../../images/svg/vine8.svg';
import { ReactComponent as Vine3 } from '../../images/svg/vine9.svg';
import { ReactComponent as Vine4 } from '../../images/svg/vine10.svg';
import { ReactComponent as FollowerVine1 } from '../../images/svg/followerVine4.svg';
import { ReactComponent as FollowerVine2 } from '../../images/svg/followerVine2.svg';
import { ReactComponent as FollowerVine3 } from '../../images/svg/followerVine3.svg';
import { ReactComponent as FollowerVine4 } from '../../images/svg/followerVine1.svg';

import { ReactComponent as MobileVine1 } from '../../images/svg/mobileVine1.svg';
import { ReactComponent as MobileVine2 } from '../../images/svg/mobileVine2.svg';
import { ReactComponent as MobileVine3 } from '../../images/svg/mobileVine3.svg';
import { ReactComponent as MobileVine4 } from '../../images/svg/mobileVine4.svg';
import { ReactComponent as MobileFollowerVine1} from '../../images/svg/mobileFollowerVine1.svg';
import { ReactComponent as MobileFollowerVine2} from '../../images/svg/mobileFollowerVine2.svg';
import { ReactComponent as MobileFollowerVine3} from '../../images/svg/mobileFollowerVine3.svg';
import { ReactComponent as MobileFollowerVine4} from '../../images/svg/mobileFollowerVine4.svg';

import '../../css/reusableComponentStylings/VineAnimationStyling.css';

const VineAnimation = ({
                           className = "",
                           animationInterval = 16000,
                           enableMobileVersion = true,
                           mobileBreakpoint = 768,
                           vineOpacity = 1
                       }) => {
    const [isMobile, setIsMobile] = useState(false);
    const [currentVineIndex, setCurrentVineIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);

    // Define vine components arrays
    const vines = [Vine1, Vine2, Vine3, Vine4];
    const followerVines = [FollowerVine1, FollowerVine2, FollowerVine3, FollowerVine4];
    const mobileVines = [MobileVine1, MobileVine2, MobileVine3, MobileVine4];
    const mobileFollowerVines = [MobileFollowerVine1, MobileFollowerVine2, MobileFollowerVine3, MobileFollowerVine4];

    // Check if device is mobile
    useEffect(() => {
        const checkIfMobile = () => {
            setIsMobile(window.innerWidth <= mobileBreakpoint);
        };

        // Check on mount
        checkIfMobile();

        // Add resize listener
        window.addEventListener('resize', checkIfMobile);

        // Cleanup
        return () => window.removeEventListener('resize', checkIfMobile);
    }, [mobileBreakpoint]);

    // Animation to switch through vine paths
    useEffect(() => {
        const vineTimer = setTimeout(() => {
            setIsTransitioning(true); // Start transition
            setCurrentVineIndex((prevIndex) => (prevIndex + 1) % vines.length);
        }, animationInterval);

        return () => clearTimeout(vineTimer);
    }, [currentVineIndex, vines.length, animationInterval]);

    // Get the current vine components
    const CurrentVine = vines[currentVineIndex];
    const CurrentFollowerVine = followerVines[currentVineIndex];
    const CurrentMobileVine = mobileVines[currentVineIndex];
    const CurrentMobileFollowerVine = mobileFollowerVines[currentVineIndex];

    useEffect(() => {
        const calculatePathLengths = () => {
            const paths = document.querySelectorAll('.vine-path path, .mobile-vine-test path');

            paths.forEach(path => {
                const pathLength = path.getTotalLength();
                path.style.setProperty('--path-length', `${pathLength}px`);
                path.style.strokeDasharray = `${pathLength}`;
                path.style.strokeDashoffset = `${pathLength}`;
            });

            // End transition after path calculations are complete
            setTimeout(() => {
                setIsTransitioning(false);
            }, 50); // Small delay to ensure styles are applied
        };

        // Calculate after component mounts and SVG renders (for initial load and transitions)
        const timer = setTimeout(calculatePathLengths, 100);
        return () => clearTimeout(timer);
    }, [currentVineIndex]);

    if (isMobile && enableMobileVersion) {
        return (
            <div className="vine-wrapper" style={{opacity: vineOpacity ?? 1}}>
                <div className={`mobile-vine-test ${className} ${isTransitioning ? 'transitioning' : ''}`}>
                    <CurrentMobileVine className="vine-path"/>
                </div>
                <div className={`mobile-follower-vine-test ${isTransitioning ? 'transitioning' : ''}`}>
                    <CurrentMobileFollowerVine className={"vine-path"}/>
                </div>
            </div>
        );
    }

    return (
        <div className="vine-wrapper" style={{opacity: vineOpacity ?? 1}}>
            <div className={`vine-test ${isTransitioning ? 'transitioning' : ''}`}>
                <CurrentVine/>
            </div>
            <div className={`follower-vine-test ${isTransitioning ? 'transitioning' : ''}`}>
                <CurrentFollowerVine/>
            </div>
        </div>
    );
};

export default VineAnimation;